import { render, staticRenderFns } from "./TheAgeOfDiagnosisArticle.vue?vue&type=template&id=fdc5f6a6&"
import script from "./TheAgeOfDiagnosisArticle.vue?vue&type=script&lang=js&"
export * from "./TheAgeOfDiagnosisArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports